import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { useMediaQuery } from "react-responsive"
import queryString from "query-string"
import { Card, CardContent, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core"
import NavigationBar from "../common/NavigationBar"
import ErrorFallbackWrapper from "../common/ErrorFallbackWrapper"
import { DIYActions } from "../../actions"
import RSSITicketsTable from "../Layouts/components/components/RSSITicketsTable"

const colors = { blue: "#1976D2", green: "#2E7D32", purple: "#512da8", orange: "#F57C00" }

const useStyles = makeStyles((theme) => ({
    footerMobile: { marginLeft: theme.spacing(1), marginTop: theme.spacing(2) },
    footer: { marginLeft: theme.spacing(5), marginTop: theme.spacing(2) },
    rootDesktop: { marginTop: theme.spacing(1), marginLeft: theme.spacing(2), marginRight: theme.spacing(2) },
    rootTablet: { marginTop: theme.spacing(1), marginLeft: theme.spacing(5), marginRight: theme.spacing(5) },
    rootMobile: { marginTop: theme.spacing(1), marginLeft: theme.spacing(1), marginRight: theme.spacing(1) },
    tablecell: { padding: "6px 4px 6px 4px", border: `1px solid #000000` },
    hoverlesstablerow: { display: "table-row", paddingTop: 5, paddingBottom: 5, "&:hover": { backgroundColor: "#212121", } },
    statusChip: { position: "absolute", right: 20, top: 70 },
}))

const responsiveData = () => {
    let desktopOrLaptop = useMediaQuery({ query: "(min-width: 1024px)" })
    let tablet = useMediaQuery({ query: "(max-width: 768px)" })
    let notMobile = useMediaQuery({ query: "(min-width: 450px)" })
    let mobile = useMediaQuery({ query: "(max-width: 450px)" })
    let portrait = useMediaQuery({ query: "(orientation: portrait)" })

    return { isDesktopOrLaptop: desktopOrLaptop, isTablet: tablet && notMobile, isMobile: mobile, isPortrait: portrait }
}

const RSSIDeeplink = ({ }) => {
    const classes = useStyles()
    const responsive = responsiveData()

    const [message, setMessage] = React.useState(null)
    const [record, setRecord] = React.useState([{}])
    const [assignedUser, setAssignedUser] = React.useState({ username: null, name: null, contact: null, email: null, company: null })

    var profile = { username: "devuser", fname: "DEV", lname: "User", contact_number: "+1 9876543210", email: "dev.user@gmail.com", company: "DEV Company", customer: "T-Mobile", accounttype: "ODS", access: "Homepage" }
    var pages = [[], [], [], []]

    const query = queryString.parse(location.search)
    const pageRef = React.useRef(false)
    if (!pageRef.current) {
        DIYActions.RSSI.deeplink(query).then((response) => {
            if (response.data.status === "SUCCESS") {
                setRecord(response.data.record)
                setAssignedUser(response.data.user)
            }
            setMessage(response.data.message)
        }).catch(console.error)
        pageRef.current = true
    }

    return (
        <React.Fragment>
            <NavigationBar pages={pages} profile={profile} responsive={responsive} deeplink />
            <ErrorFallbackWrapper>
                {
                    message === "SUCCESS" ? (
                        <Card className={responsive.isDesktopOrLaptop ? classes.rootDesktop : responsive.isTablet ? classes.rootTablet : responsive.isMobile ? classes.rootMobile : classes.rootDesktop}>
                            <CardContent style={{ paddingBottom: 0, paddingTop: 0 }}>
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow className={classes.hoverlesstablerow}>
                                                <TableCell className={classes.tablecell} variant="head" size="small" align="center" style={{ width: "150px" }} ><Typography variant="h5" color="textSecondary">ESP Workorder</Typography></TableCell>
                                                <TableCell className={classes.tablecell} variant="head" size="small" align="center" style={{ width: "150px" }} ><Typography variant="h5" color="textSecondary">Sitename</Typography></TableCell>
                                                <TableCell className={classes.tablecell} variant="head" size="small" align="center" style={{ width: "150px" }} ><Typography variant="h5" color="textSecondary">Customer</Typography></TableCell>
                                                <TableCell className={classes.tablecell} variant="head" size="small" align="center" style={{ width: "150px" }} ><Typography variant="h5" color="textSecondary">Region</Typography></TableCell>
                                                <TableCell className={classes.tablecell} variant="head" size="small" align="center" style={{ width: "150px" }} ><Typography variant="h5" color="textSecondary">Market</Typography></TableCell>
                                                <TableCell className={classes.tablecell} variant="head" size="small" align="center" style={{ width: "150px" }} ><Typography variant="h5" color="textSecondary">Technology</Typography></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow className={classes.hoverlesstablerow}>
                                                <TableCell className={classes.tablecell} variant="body" size="small" align="center" style={{ width: "150px" }} ><Typography variant="h6" color="textSecondary">{record.ESPWorkorder}</Typography></TableCell>
                                                <TableCell className={classes.tablecell} variant="body" size="small" align="center" style={{ width: "150px" }} ><Typography variant="h6" color="textSecondary">{record.Sitename}</Typography></TableCell>
                                                <TableCell className={classes.tablecell} variant="body" size="small" align="center" style={{ width: "150px" }} ><Typography variant="h6" color="textSecondary">{record.Customer}</Typography></TableCell>
                                                <TableCell className={classes.tablecell} variant="body" size="small" align="center" style={{ width: "150px" }} ><Typography variant="h6" color="textSecondary">{record.Region}</Typography></TableCell>
                                                <TableCell className={classes.tablecell} variant="body" size="small" align="center" style={{ width: "150px" }} ><Typography variant="h6" color="textSecondary">{record.Market}</Typography></TableCell>
                                                <TableCell className={classes.tablecell} variant="body" size="small" align="center" style={{ width: "150px" }} ><Typography variant="h6" color="textSecondary">{record.Technology}</Typography></TableCell>
                                            </TableRow>
                                            <RSSITicketsTable tickets={[record]} colSpan={9} classnames={{ tablecell: classes.tablecell }} selectedTicketId={record.id} deeplinked />
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CardContent>
                        </Card>
                    ) : <Card className={responsive.isDesktopOrLaptop ? classes.rootDesktop : responsive.isTablet ? classes.rootTablet : responsive.isMobile ? classes.rootMobile : classes.rootDesktop}>
                        <CardContent style={{ paddingBottom: 0, paddingTop: 0 }}><Typography variant="h5" color="textSecondary">{message}</Typography></CardContent>
                    </Card>
                }
            </ErrorFallbackWrapper>
            <Typography className={responsive.isMobile ? classes.footerMobile : classes.footer} variant="h6">{"Ericsson Support Protal "}&copy;{" Ericsson Inc. "}{new Date().getFullYear()}</Typography>
        </React.Fragment>
    )
}

export default RSSIDeeplink
